const state = {
    data: [],
    orderables: [{
            title: 'Nome',
            name: 'nome'
        },
        {
            title: 'Cadastrado em',
            name: 'created_at'
        }
    ],
    filterGroups: [{
        name: 'Grupo Signatário',
        filters: [{
                title: 'Nome',
                name: 'nome',
                type: 'string'
            },
            {
                title: 'Cadastrado em',
                name: 'created_at',
                type: 'datetime'
            }
        ]
    }]
};

const mutations = {
    SET_GRUPO_SIGNATARIOS: (state, payload) => {
        state.data = payload;
    },
};

const actions = {
    setGrupoSignatarios: (context, payload) => {
        context.commit('SET_GRUPO_SIGNATARIOS', payload);
    },
};
export default {
    state,
    mutations,
    actions
};